import { validate as validatePhone } from './validators/phone'
import {
  FORM_LOGIN,
  FORM_PASSWORD_RECOVERY,
  FORM_SMS,
  FORM_SIGNUP,
} from '../shared/formStates'

export const EMAIL_REGEXP = /^\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
export const PHONE_REGEXP = /^[0-9]{5,}/

const validateSignUp = ({
  name,
  password,
  rpassword,
  email,
  privacyPolicy,
  privacyPolicy2,
  flownBefore,
  phone,
  amountSpent
}) => {
  const errors = []

  if (!name) errors.push('name')
  if (!password) errors.push('password')
  if (!rpassword) errors.push('rpassword')
  if (!email) errors.push('email')
  if (!privacyPolicy) errors.push('privacyPolicy')
  if (!privacyPolicy2) errors.push('privacyPolicy2')

  if (flownBefore === null) {
    errors.push('flownBefore')
  }
  if (flownBefore && !amountSpent) {
    errors.push('survey')
  }

  if (password.length < 6) errors.push('password.tooshort')

  if (password !== rpassword) {
    errors.push('rpassword.nonmatch')
  }
  if (!EMAIL_REGEXP.test(email)) {
    errors.push('email.notvalid')
  }
  if (!validatePhone(phone)) {
    errors.push('phone.notvalid')
  }

  return errors
}

const validateEmail = ({ email }) => {
  const errors = []
  if (!email) errors.push('name')
  if (!EMAIL_REGEXP.test(email)) {
    errors.push('email.notvalid')
  }

  return errors
}

const validateLogin = ({ email, password }) => {
  const errors = validateEmail({ email })

  if (!password) errors.push('password')

  return errors
}

const validateSMS = () => {
  return []
}

export const validateForm = (formState, state) => {
  if (formState === FORM_SIGNUP) return validateSignUp(state)
  if (formState === FORM_LOGIN) return validateLogin(state)
  if (formState === FORM_SMS) return validateSMS(state)
  if (formState === FORM_PASSWORD_RECOVERY) return validateEmail(state)
}
